





import Vue from 'vue'
export default Vue.extend({
    mounted() {
        //  Next tick bitch
        this.$nextTick(() => {
            let elem = this.$refs['calendly']

            //  Embed script for calendly
            let embedCalendly = document.createElement('script')
            embedCalendly.setAttribute(
                'src',
                'https://assets.calendly.com/assets/external/widget.js'
            )
            embedCalendly.setAttribute('async', 'async')

            let inline = document.createElement('script')
            inline.innerHTML = `Calendly.initInlineWidget({url: 'https://calendly.com/YOURLINK'});`

            elem.appendChild(embedCalendly)
            elem.appendChild(inline)
        })
    }
})
